import { getThirdPartyUrl, isHostLinkUrl } from './editor-config';

export function markdownItThirdPartyLink(md: any) {
  md.renderer.rules.link_open = (
    tokens: any,
    idx: any,
    options: any,
    env: any,
    self: any,
  ) => {
    const token = tokens[idx];

    const href = token.attrGet('href');
    const isHost = isHostLinkUrl(href);

    if (!isHost) {
      token.attrSet('target', '_blank');
      token.attrSet('href', getThirdPartyUrl(href));
    }

    return self.renderToken(tokens, idx, options);
  };
}
